import './App.css';
import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Header from "./Header";
import Footer from './Footer';
import { Text } from "react-native";
import { withRouter } from "react-router-dom";
import { TITLE_NOT_FOUND } from './Constant';
import { MESSAGE_NOT_FOUND } from './Constant';

class NotFound extends React.Component {

    componentDidMount(){
        document.title = {TITLE_NOT_FOUND}.TITLE_NOT_FOUND;
    }

    render() {
        return (
            <div className="page-container">
                <Header />
                <div className="text-center content-wrap">
                    <Container>
                        <Row className="code-row-style" style={{marginTop: '10px'}}>
                            <Text style={{fontWeight: 'bold', color: '#7f7a7a', fontSize: '20px'}}>
                                {MESSAGE_NOT_FOUND}
                            </Text>
                        </Row>
                    </Container>
                </div>
                <Footer />
            </div>
        );
    }
}

export default withRouter(NotFound);